import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";

// Aviso legal fijo y no intrusivo en la página principal.
export function DisclaimerBanner() {
  const { t } = useTranslation();
  return (
    <div data-testid="legal-disclaimer"
      className="flex gap-2 items-start bg-amber-50 border border-amber-200 text-amber-900 rounded-sm px-3 py-2">
      <Info className="w-4 h-4 mt-0.5 shrink-0 text-amber-600" />
      <p className="text-xs leading-relaxed">
        <span className="font-semibold">{t("disclaimer.strong")}</span>{t("disclaimer.rest")}
      </p>
    </div>
  );
}
